import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlanningEditForm } from "@/features/rh/planning/components/PlanningEditForm";

export const Route = createFileRoute("/_app/rh/planning/$id/edit")({
  loader: requirePermission(PERMISSIONS.RH.FEUILLES_DE_TEMPS.EDIT),
  staticData: {
    title: "Modifier l'élément",
    icon: null,
    permission: PERMISSIONS.RH.FEUILLES_DE_TEMPS.EDIT,
    module: "rh",
    showInTab: false,
    showInBreadcrumb: true,
  },
  component: PlanningEditForm,
});
